// src/components/pages/QrCodeGenerator.js

import React from 'react';
import QRCode from 'react-qr-code';

const QrCodeGenerator = () => {
    // กำหนด URL ที่ต้องการแปลงเป็น QR code
    const url = "https://stg-e-consent.sgcapital.dev/e-consent/?department=Marketing&consent_type=Group&consent_id=SGC-EConsent&company_id=1&source=personal_data_consent";

    return (
        <div style={{ padding: "20px" }}>
            <h1>QR Code สำหรับ E-Consent</h1>

            {/* ใช้ component QRCode โดยส่ง prop 'value' เป็น URL ที่ต้องการ
        คุณสามารถปรับแต่ง style และขนาดได้ตามต้องการ
      */}
            <div style={{ background: 'white', padding: '16px' }}>
                <QRCode
                    value={url}
                    size={256} // กำหนดขนาดของ QR code (เป็น pixel)
                    viewBox={`0 0 256 256`} // เพื่อให้ปรับขนาดได้ง่าย
                />
            </div>

            <p style={{ marginTop: '20px', wordBreak: 'break-all' }}>
                URL: {url}
            </p>
        </div>
    );
};

export default QrCodeGenerator;